import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

export const initialState = {
  user: createAsyncObject({}),
  orderHistory: createAsyncObject({}), // previously userOrder
  savedCards: createAsyncObject([])
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case C.GET_USER_FACEBOOK_REQUEST: updateForAsyncRequest(draftState.user); break
    case C.GET_USER_FACEBOOK_FAILURE: updateForAsyncFailure(action)(draftState.user); break
    case C.GET_USER_FACEBOOK_SUCCESS: {
      const { ocaExist, mcaExist } = action.payload
      if (ocaExist && mcaExist) {
        updateForAsyncSuccess(action.payload)(draftState.user)
      }
      break
    }
    case C.GET_USER_REQUEST: updateForAsyncRequest(draftState.user); break
    case C.GET_USER_FAILURE: updateForAsyncFailure(action)(draftState.user); break
    case C.UPDATE_USER_SUCCESS:
    case C.LOGIN_SUCCESS:
    case C.REGISTER_SUCCESS:
    case C.GET_USER_SUCCESS:
      updateForAsyncSuccess(action.payload)(draftState.user)
      break
    case C.LOGOUT_SUCCESS:
      draftState.user.fetched = false
      draftState.user.data = {}
      break
    case C.SET_DEFAULT_USER_DELIVERY_ADDRESS_REQUEST: draftState.user.data.preferredDeliveryAddress = { id: action[1] }; break
    case C.SET_DEFAULT_USER_DELIVERY_ADDRESS_SUCCESS:
      // TODO: add the flag into Oddle Pass wrapper to detect this response from Oddle Pass server
      // this handle for response from Oddle Pass server, it response with data inside of payload
      // the api of Oddle Pass will response with customer's info which contain preferredDeliveryAddressId, don't have anymore about address's info
      // so we need to find the address with preferredDeliveryAddressId from draftState.user.data.deliveryAddresses
      if (action.payload.success && action.payload.data) {
        draftState.user.data.preferredDeliveryAddress = draftState.user.data.deliveryAddresses.find(address => address.id === action.payload.data.preferredDeliveryAddressId)
      } else {
        // this handle for response from OMS server
        draftState.user.data.preferredDeliveryAddress = action.payload
      }
      break
    case C.CREATE_USER_DELIVERY_ADDRESS_SUCCESS:
      if (!(draftState.user.data.deliveryAddresses)) {
        draftState.user.data.deliveryAddresses = []
      }
      if (action.payload.success && action.payload.data) {
        draftState.user.data.deliveryAddresses.push(action.payload.data)
      } else {
        draftState.user.data.deliveryAddresses.push(action.payload)
      }
      break
    case C.UPDATE_USER_DELIVERY_ADDRESS_SUCCESS:
      let index = 0
      const payload = action.payload.success && action.payload.data ? action.payload.data : action.payload
      draftState.user.data.deliveryAddresses.find((a, i) => {
        if (a.id === payload.id) index = i
      })
      draftState.user.data.deliveryAddresses[index] = payload
      break
    case C.REMOVE_USER_DELIVERY_ADDRESS_SUCCESS:
      draftState.user.data.deliveryAddresses = draftState.user.data.deliveryAddresses.filter((place) => place.id !== action.payload.deletedAddressId)
      if (draftState.user.data.preferredDeliveryAddress && draftState.user.data.preferredDeliveryAddress.id === action.payload.deletedAddressId) {
        draftState.user.data.preferredDeliveryAddress = null
      }
      break
    case C.REMOVE_USER_DELIVERY_ADDRESS_FAILURE: draftState.user.error = action.error; break
    case C.GET_USER_ORDER_REQUEST: updateForAsyncRequest(draftState.orderHistory); break
    case C.GET_USER_ORDER_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.orderHistory); break
    case C.GET_USER_ORDER_FAILURE: updateForAsyncFailure(action)(draftState.orderHistory); break
    case C.GET_ALL_ADDRESSES_FROM_OP_SUCCESS:
      if (action.payload) {
        draftState.user.data.deliveryAddresses = action.payload
        const preferredDeliveryAddress = action.payload.find((address) => address.preferredDeliveryAddress)
        if (preferredDeliveryAddress) {
          draftState.user.data.preferredDeliveryAddress = preferredDeliveryAddress
        }
      }
      break
    case C.GET_ALL_ADDRESSES_FROM_OP_FAILURE: draftState.user.data.fetchedAddressWithError = action.error; break
    case C.GET_ALL_SAVED_CARDS_FROM_OP_REQUEST: updateForAsyncRequest(draftState.savedCards); break
    case C.GET_ALL_SAVED_CARDS_FROM_OP_SUCCESS: updateForAsyncSuccess(action.payload.data)(draftState.savedCards); break
    case C.GET_ALL_SAVED_CARDS_FROM_OP_FAILURE: updateForAsyncFailure(action)(draftState.savedCards); break
  }
})
